"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressSearchInput = void 0;
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const google_maps_react_1 = require("google-maps-react");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_places_autocomplete_1 = __importStar(require("react-places-autocomplete"));
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("../");
const StyledList = styled_components_1.default.ul `
	cursor: pointer;
	padding: 0;
	margin: 0;
`;
const SuggestionItem = styled_components_1.default.li `
	list-style-type: none;
	cursor: pointer;
	background-color: ${({ active, theme }) => active ? theme.gray4 : theme.white};
	padding-top: 5px;
	margin: 0;
	display: flex;
	align-items: center;
	color: black;
`;
const AddressSearchInput = (_a) => {
    var { updateLocation, form, field, handleAutocompletePostcode, placeholder, google, loadingText } = _a, props = __rest(_a, ["updateLocation", "form", "field", "handleAutocompletePostcode", "placeholder", "google", "loadingText"]);
    const i18n = react_i18next_1.useTranslation();
    const searchOptions = {
        componentRestrictions: { country: ["au"] },
        types: ['address']
    };
    function setAddressComponents(addressComponents) {
        addressComponents.forEach(component => {
            const { type, short_name } = component;
            switch (type) {
                case 'locality':
                    form.setFieldValue('suburb', short_name);
                    return;
                case 'administrative_area_level_1':
                    form.setFieldValue('state', short_name);
                    return;
                case 'postal_code':
                    form.setFieldValue('postcode', short_name);
                    return;
                case 'subpremise':
                    form.setFieldValue('address2', short_name);
                    return;
                default:
                    return;
            }
        });
    }
    function handleSelect(addr) {
        let addressComponents = [];
        let newPostcode = null;
        react_places_autocomplete_1.geocodeByAddress(addr)
            .then((res) => {
            let formattedAddress = '';
            res[0].address_components.forEach(c => {
                addressComponents.push({ type: c.types[0], short_name: c.short_name, long_name: c.long_name });
                if (c.types[0] === 'street_number') {
                    formattedAddress = c.short_name;
                }
                if (c.types[0] === 'route') {
                    formattedAddress += ` ${c.short_name}`;
                }
                if (c.types[0] === 'postal_code') {
                    newPostcode = c.short_name;
                }
            });
            const previousPostcode = form.initialValues.postcode;
            if (handleAutocompletePostcode && !lodash_1.default.isEmpty(previousPostcode) && newPostcode !== previousPostcode) {
                handleAutocompletePostcode();
            }
            else {
                form.setFieldValue(field.name, formattedAddress);
                setAddressComponents(addressComponents);
                updateLocation === null || updateLocation === void 0 ? void 0 : updateLocation(res[0]);
            }
        })
            .catch((error) => console.error(error));
    }
    function handleAutoCompleteChange({ name, form, search, id }) {
        form.setFieldValue(name, search);
        const autocompleteField = document.getElementById(id);
        autocompleteField && autocompleteField.removeAttribute('aria-activedescendant');
    }
    return (react_1.default.createElement(react_places_autocomplete_1.default, { value: field.value, onChange: search => handleAutoCompleteChange({ name: field.name, id: field.name, form, search }), onSelect: handleSelect, searchOptions: searchOptions, googleCallbackName: 'googleInitCallback' }, ({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
        const additionalProps = {
            name: field.name,
            id: field.name,
            className: 'location_search_input',
            placeholder: placeholder,
        };
        const autocompleteInputProps = getInputProps(additionalProps);
        let suggestionHelp = '';
        if (!lodash_1.default.isEmpty(suggestions)) {
            suggestionHelp = i18n.t('general.suggestions_help', { length: suggestions.length });
        }
        return (react_1.default.createElement("div", { className: "autocomplete_root" },
            react_1.default.createElement(__1.Input, Object.assign({}, autocompleteInputProps, { icon: pro_light_svg_icons_1.faAddressBook, "aria-owns": "autocomplete-dropdown-container", hintElement: react_1.default.createElement("div", { id: "suggestions-help", className: "sr-only", role: "status", "aria-atomic": "true", "aria-live": "assertive" }, suggestionHelp), "aria-activedescendant": null }, props, (props.autoComplete ? {} : { autoComplete: 'off' }))),
            loading && react_1.default.createElement("div", null, loadingText),
            suggestions.length > 0 &&
                react_1.default.createElement(StyledList, { id: "autocomplete-dropdown-container", className: "autocomplete-dropdown-container", role: "listbox", "aria-labelledby": "location_search_input" }, suggestions.map((suggestion, i) => {
                    var _a;
                    if (suggestion.active) {
                        (_a = document.getElementById(autocompleteInputProps.id)) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-activedescendant', `suggestion_item--${i + 1}`);
                    }
                    return (react_1.default.createElement(SuggestionItem, Object.assign({}, getSuggestionItemProps(suggestion, { className: 'suggestion_item' }), { active: suggestion.active, id: `suggestion_item--${i + 1}`, key: suggestion.placeId, "aria-selected": suggestion.active }), suggestion.description));
                }))));
    }));
};
exports.AddressSearchInput = AddressSearchInput;
exports.default = google_maps_react_1.GoogleApiWrapper({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API || ''
})(exports.AddressSearchInput);
